import rest from "../rest";
import commonUtils from "./commonUtils";

class AuthUtils {

    async login(username, password) {
        const url = "/rest/login";
        const formData = new FormData();
        formData.append("username", username);
        formData.append("password", password);

        const options = {
            method: "post",
            credentials: "same-origin",
            body: formData,
        };
        commonUtils.dispatchEvent("fetch");
        const response = await fetch(url, options);
        if (response.ok) {
            return true;
        }
        return false;
    }

    async logout() {
        const url = "/rest/logout";
        await rest.get(url);
        window.location.replace("/");
    }

    isAuthenticated() {
        return document.cookie.match("WWC_AUTH_COOKIE=true") !== null;
    }
}
const authUtils = new AuthUtils();
export default authUtils;